<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
          <el-breadcrumb-item :to="{ path: '/product', query:{page:$route.query.frompage || 1, keyword:$route.query.keyword} }">商品列表 P{{$route.query.frompage || 1}}</el-breadcrumb-item>
          <el-breadcrumb-item>拖曳排序</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </template>
    <template slot="right">
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">

      <ul class="list-sortable">

        <li>
          <div class="th-in-sortable-list">
          </div>
          <div class="th-in-sortable-list">
            名稱
          </div>
          <div class="th-in-sortable-list">
            順序
          </div>
        </li>

        <draggable v-model="dataList"
          @update="onSortChanged"
          handle=".drag-handler">
          <li v-for="(data,idx) in dataList" :key="idx" class="drag-handler">
            <div class="td-in-sortable-list">
              <i class="el-icon-s-grid"/>
            </div>
            <div class="td-in-sortable-list">
              {{data.Tw.Name}}
            </div>
            <div class="td-in-sortable-list">
              {{data.SortOrder}}
            </div>
          </li>
        </draggable>
      </ul>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import draggable from 'vuedraggable'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
// import MixinLoading from '@/utils/mixin-loading-multithread.vue'
export default {
  mixins: [MixinLanguages],
  components: {
    LeftMenu,
    TopHeader,
    draggable
  },
  data () {
    return {
      isLoading: false,
      dataList: []
    }
  },
  computed: {
  },
  methods: {
    initData () {
      let dataList = this.$store.state.product.list.filter(o => !o.TeamBuyingID).filter(this.isPublished)
      dataList.sort((o1, o2) => o1.SortOrder - o2.SortOrder)
      this.dataList = dataList
    },
    onSortChanged (o1, o2) {
      let payload = {
        ids: [],
        sorts: []
      }
      for (let i = 0; i < this.dataList.length; ++i) {
        payload.ids.push(this.dataList[i].ID)
        payload.sorts.push(i + 1)
      }
      this.$services.product.batchUpdateSort(this, payload).then(res => {
        for (let i = 0; i < this.dataList.length; ++i) {
          this.$set(this.dataList[i], 'SortOrder', i + 1)
        }
      })
    },
    isPublished (product) {
      let obj = product.Tw
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return product.IsActive && obj.IsActive && (obj.ReleaseAt == null || moment().isAfter(obj.ReleaseAt)) && (obj.CloseAt == null || moment().isBefore(closedAt))
    }
  },
  created () {
    if (
      !this.$store.state.post.isFetched &&
      !this.$store.state.post.isFetching
    ) {
      this.$services.fetchPostDatas(this).then(this.initData).catch(this.$handleServiceError)
    } else {
      this.initData()
    }
  }
}
</script>

<style scoped>
.list-sortable {
}
.list-sortable li {
  height: 40px;
  text-align: left;
  display: flex;
  align-items: center;
}
.list-sortable .th-in-sortable-list {
  font-weight: 700;
}
.list-sortable li > :nth-child(1) {
  flex: 50px 0 0;
}
.list-sortable li > :nth-child(2) {
  flex: 1;
}
.list-sortable li > :nth-child(3) {
  flex: 50px 0 0;
}
.drag-handler {
  cursor: grab;
}
</style>
